import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const StandbyReserveRules = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Standby / Reserve Rules</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={baseline.standbyCountsAsDuty}
                  onChange={(e) => handleChange('standbyCountsAsDuty', e.target.checked)}
                />
              }
              label="Standby Counts as Duty"
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, ml: 4 }}>
              When enabled, standby time counts as duty time. Otherwise, only counts when crew is called.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Min Reserve Notice Hours"
              type="number"
              value={baseline.minReserveNoticeHours}
              onChange={(e) => handleChange('minReserveNoticeHours', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 24, step: 0.5 }}
              helperText="CAR Section 7, Series J - Reserve duty notice"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default StandbyReserveRules;
